module.exports = __webpack_public_path__ + "img/7.fb21c990.jpg";